import Decimal from "decimal.js";
import { Cusip, Ticker } from "../../Types";
const isDefinedPosition = (item) => {
    return item !== undefined;
};
const convertHoldingsBreakdownToPositions = (holdingsBreakdown) => {
    if (holdingsBreakdown.length === 0) {
        return [];
    }
    return holdingsBreakdown
        .map((item) => {
        if (item.cusip !== null) {
            return {
                cusip: Cusip.parse(item.cusip),
                value: new Decimal(item.weight),
            };
        }
        else if (item.ticker !== null) {
            return {
                ticker: Ticker.parse(item.ticker),
                value: new Decimal(item.weight),
                exchange: "US",
            };
        }
        return undefined;
    })
        .filter(isDefinedPosition);
};
const filterInvalidPositions = (positions, invalidPositions) => {
    if (positions.length === 0 || invalidPositions.length === 0) {
        return positions;
    }
    return positions.filter((position) => !invalidPositions.includes(position.ticker ? position.ticker : (position.cusip ?? "")));
};
const convertPortfolioPlanToEntry = (portfolioPlan) => {
    return portfolioPlan?.data.plan.entries
        .filter((el) => el.type !== "StrategicAllocation")
        .map((el) => {
        if (el.type === "Security") {
            return {
                securityId: el.securityId,
                type: "Security",
                weight: new Decimal(el.weight),
            };
        }
        else if (el.type === "NestedPlan") {
            return {
                planId: el.planId,
                type: "NestedPlan",
                weight: new Decimal(el.weight),
            };
        }
        return undefined;
    })
        .filter((entry) => entry !== undefined);
};
export { convertPortfolioPlanToEntry, convertHoldingsBreakdownToPositions, filterInvalidPositions, isDefinedPosition, };
//# sourceMappingURL=positionUtils.js.map